import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Link,
} from '@chakra-ui/react';
import type { MVRRequestTransactionType } from 'api';

interface MvrPortalAdvisoryProps {
  show: boolean;
  transactionType: MVRRequestTransactionType;
  portalUrl: string | null;
}

const NB_COPY =
  'For ease of doing business, we recommend that you complete your policy quote/bind within the carrier portal, where the MVR may be requested as part of the process.';
const PC_COPY =
  'For ease of doing business, we recommend that you complete your policy change within the carrier portal, where the MVR may be requested as part of the process.';

const MvrPortalAdvisory = ({
  show,
  transactionType,
  portalUrl,
}: MvrPortalAdvisoryProps) => {
  if (!show) return null;

  const body = transactionType === 'CLNB' ? NB_COPY : PC_COPY;

  return (
    <Box mb={4}>
      <Alert status="info" variant="subtle" borderRadius="md">
        <AlertIcon />
        <Box>
          <AlertTitle>Portal Advisory</AlertTitle>
          <AlertDescription>
            {body}{' '}
            {portalUrl ? (
              <Link href={portalUrl} isExternal color="blue.500">
                Visit the carrier portal
              </Link>
            ) : (
              'Visit the carrier portal to proceed.'
            )}
          </AlertDescription>
        </Box>
      </Alert>
    </Box>
  );
};

export default MvrPortalAdvisory;
